import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Button } from '@workspace/ui/components/Button'
import { RefreshCw } from 'lucide-react'

export const Route = createFileRoute('/maintenance')({
    component: MaintenancePage,
})

function MaintenancePage() {
    const { t } = useTranslation()

    const handleRetry = () => {
        window.location.reload()
    }

    return (
        <div className="flex min-h-screen items-center justify-center flex-col p-4 bg-background">
            <div className="w-full max-w-[480px] flex flex-col items-center gap-6 text-center">
                <img
                    src="/maintenance.png"
                    alt="Site under maintenance illustration"
                    className="h-full max-h-[360px] w-auto"
                />

                <div className="space-y-3">
                    <h1 className="text-4xl font-bold text-foreground">{t('maintenance.title')}</h1>
                    <p className="text-base text-muted-foreground">{t('maintenance.message')}</p>
                </div>

                <Button variant="default" size="lg" onPress={handleRetry} className="gap-2 mt-2">
                    <RefreshCw className="h-4 w-4" />
                    {t('maintenance.retryButton')}
                </Button>
            </div>
        </div>
    )
}
